import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';
import { CompanyGuard } from './guards/company.guard';
import { DomainGuard } from './guards/domain.guard';
import { ProfileGuard } from './guards/profile.guard';
import { ApplicationGuard } from './guards/app.guard';
import { AuthV2Guard } from './guards/authV2.guard';
import { AdminGuard } from './guards/admin.guard';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./modules/core/core.module').then(m => m.CoreModule)
  },
  {
    path: 'crm',
    loadChildren: () => import('./modules/crm/crm.module').then(m => m.CrmModule),
    canActivate: [AuthGuard, DomainGuard, ProfileGuard]
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [AuthV2Guard, AuthGuard, CompanyGuard, DomainGuard, ProfileGuard, ApplicationGuard, AdminGuard],
})
export class AppRoutingModule { }
